"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconAudioDescription = void 0;
var React = __importStar(require("react"));
var IconAudioDescription = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M11.8712,14.0961 L13.2772,14.0961 C14.8122,14.0961 15.3442,13.0151 15.3092,11.9351 C15.2732,10.9111 14.7302,9.8761 13.2772,9.8761 L11.8712,9.8761 L11.8712,14.0961 Z M13.2772,8.0231 C16.0582,8.0231 17.2582,9.9651 17.2812,11.9461 C17.3162,13.9461 16.1052,15.9811 13.2772,15.9811 L9.8712,15.9811 L9.8712,8.0231 L13.2772,8.0231 Z M7.547,13.308 L7.547,10.796 L6.047,13.308 L7.547,13.308 Z M7.07,8.003 L7.07,8 L9.227,8 L9.227,15.923 L7.43,15.923 L7.43,14.961 L5.133,14.961 L4.481,15.923 L2,15.923 L7.07,8.003 Z M17.9727,16.0004 L17.2577,16.0004 C17.7347,15.2114 18.3047,14.0034 18.3047,12.0544 C18.3047,10.0924 17.7307,8.8964 17.2577,8.1074 L17.9727,8.1074 C18.4137,8.8964 18.9607,10.0004 18.9607,12.0544 C18.9607,14.1074 18.4097,15.2114 17.9727,16.0004 Z M19.5391,16.0004 L18.8241,16.0004 C19.3011,15.2114 19.8711,14.0034 19.8711,12.0544 C19.8711,10.0924 19.2971,8.8964 18.8241,8.1074 L19.5391,8.1074 C19.9801,8.8964 20.5271,10.0004 20.5271,12.0544 C20.5271,14.1074 19.9801,15.2114 19.5391,16.0004 Z M21.0118,16.0004 L20.2968,16.0004 C20.7738,15.2114 21.3438,14.0034 21.3438,12.0544 C21.3438,10.0924 20.7698,8.8964 20.2968,8.1074 L21.0118,8.1074 C21.4528,8.8924 21.9998,9.9964 21.9998,12.0504 C21.9998,14.1044 21.4528,15.2114 21.0118,16.0004 Z" }))); };
exports.IconAudioDescription = IconAudioDescription;
exports.IconAudioDescription.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconAudioDescription;
